<template>
  <div class="row">
    <div
      class="
        col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
        pt-0
        pb-0
        d-flex
        align-items-center
      "
    >
      <img
        :src="require('../../../../assets/capsules-solid.svg')"
        width="40"
        class="mb-2"
      />
      <div class="ml-2">
        <h6 class="mb-0">
          MEDICAMENTO:
          {{ medicine.name }}
        </h6>
        <h6 class="mb-0">
          UNIDADE DE ADMINISTRAÇÃO:
          {{ medicine.unit_of_measurement_abbreviation }}
        </h6>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
      <LabelRequiredField label="GRUPO" />
      <select v-model="stock_group_id" class="form-control">
        <option value="">SELECIONE...</option>
        <option v-for="stock in stock_groups" :key="stock.id" :value="stock.id">
          {{ stock.name }}
        </option>
      </select>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
      <LabelRequiredField :label="medicine.unit_of_measurement_abbreviation" />
      <input v-model="amount" type="number" class="form-control" />
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
      <LabelRequiredField label="LOTE" />
      <input v-model="lot" type="text" class="form-control" />
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
      <LabelRequiredField label="DATA DE VENCIMENTO" />
      <input v-model="due_date" type="month" class="form-control" />
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
      <label>DESCRIÇÃO</label>
      <ChromeSpeechToTextTextarea rows="2" max-rows="2" v-model="description" />
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 d-flex justify-content-between">
      <v-btn @click="$bvModal.hide('inputMedicine')" class="btn-cancel"
        ><i class="fas fa-times mr-2 text-twenty"></i> CANCELAR</v-btn
      >
      <v-btn :disabled="loading" @click="execute" class="btn-save"
        ><i class="mr-2 text-twenty fa fa-check"></i>
        {{ loading ? "CARREGANDO" : "ADICIONAR" }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import api from "../../../../services/api";

import APIGet from "../../../../lib/api-get";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "InputMedicine",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    ChromeSpeechToTextTextarea,
  },

  props: {
    medicine: { type: Object, required: true },
    resident_id: { type: [String, Number], required: true },
  },

  data() {
    return {
      stock_group_id: "",
      amount: "",
      lot: "",
      due_date: "",
      description: "",

      stock_groups: [],

      errors: [],
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      await this.getStockGroups();
    },

    async getStockGroups() {
      this.loading = true;
      let params = { type: "MEDICINE" };
      const { error, errors, stock_groups } = await APIGet.getStockGroups(
        params
      );
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async execute() {
      try {
        this.loading = true;

        let {
          resident_id,
          stock_group_id,
          lot,
          amount,
          due_date,
          description,
          medicine,
        } = this;

        let { unit_of_measurement_id, unit_of_measurement_value } = medicine;

        let params = {
          resident_id,
          stock_group_id,
          lot,
          amount,
          due_date,
          description,
          medicine,
          unit_of_measurement_id,
          unit_of_measurement_value,
          from: "ENTRY_MEDICINE",
        };

        const response = await api.post(
          "/rest-home/resident/stock/medicine-entry",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$bvModal.hide("inputMedicine");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
